export default {"src":"/_next/static/media/people.a7c7d8a8.svg","height":293,"width":368,"blurWidth":0,"blurHeight":0};